import { Stack } from "@mui/material";

import { SelectableBox } from "../../../components/SelectableBox";

interface SingleSelectQuestionProps<T extends string> {
  options: { value: T; label: string }[];
  value: T | undefined;
  onChange: (value: T) => void;
}

export function SingleSelectQuestion<T extends string>(props: SingleSelectQuestionProps<T>) {
  const { options, value, onChange } = props;

  return (
    <Stack spacing={4}>
      {options.map((option) => (
        <SelectableBox
          key={option.value}
          isSelected={value === option.value}
          sx={(theme) => ({
            boxShadow: "none",
            border: 1,
            borderColor: theme.palette.border?.primary,
          })}
          onToggleSelect={() => {
            onChange(option.value);
          }}
        >
          {option.label}
        </SelectableBox>
      ))}
    </Stack>
  );
}
